import type { PlannerAction } from '../../core/events';

export const SUBSCRIPTION_URL = 'https://www.240tutoring.com/';

/** What a teacher sees when the subscriber switch is on and they do not have a subscription. */
export function SubscriptionPreview({ onRetry, onTrack }: {
  onRetry(): void;
  onTrack(action: PlannerAction, properties?: Record<string, string | number | boolean | string[]>): void;
}) {
  return <div className="subscription-preview">
    <section className="subscription-notice" aria-labelledby="subscription-title">
      <div className="eyebrow">INCLUDED WITH A 240 SUBSCRIPTION</div>
      <h2 id="subscription-title">Get a 240 subscription to use 240 Planner.</h2>
      <p>Lay your course’s official standards across your school calendar as a sequence of units, then open the plan each week to see what you teach now and next, with the 240 topics that prepare you for it.</p>
      <div className="subscription-actions">
        <a className="primary" href={SUBSCRIPTION_URL} target="_blank" rel="noopener noreferrer" onClick={() => onTrack('subscription_cta_clicked', { destination: SUBSCRIPTION_URL, placement: 'subscription_preview' })}>Get a 240 subscription <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
        <button className="text-button" type="button" onClick={onRetry}>Already subscribed? Check again</button>
      </div>
    </section>
  </div>;
}
